/* src/app/shared/components/loaders/overlay-loader/overlay-loader.component.scss */
.overlay-loader {
  position: absolute;
  top: -24px;
  left: -24px;
  height: calc(100% + 48px);
  width: calc(100% + 48px);
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 9998;
}
.loader-icon {
  content: var(--loader);
  position: absolute;
  top: 40%;
  left: 45%;
  opacity: 1;
  z-index: 9999;
}
/*# sourceMappingURL=overlay-loader.component-EDWIFCPU.css.map */
